import { useAtomValue } from 'jotai';
import { useUserTDK } from '../shared/use-user-tdk';
import { $CurrentAvailableUserOrNull } from '@user/shared/atoms/current-user';
import { CommonPageTWCard } from '@lemon8/web-app-shared/ssr';
import { loadable } from 'jotai/utils';

const useTwCardImage = () => {
  const loadableUser = useAtomValue(loadable($CurrentAvailableUserOrNull));

  if (loadableUser.state !== 'hasData' || !loadableUser.data) {
    return '';
  }

  return loadableUser.data.avatar || '';
};

export const UserTwitter = () => {
  const { title, description } = useUserTDK();

  const twitterCardInfo = {
    twCardTitle: title,
    twCardDesc: description,
    twCardImageSrc: useTwCardImage(),
  };

  return <CommonPageTWCard {...twitterCardInfo} />;
};
